import { Scene, WebXRDefaultExperience } from "babylonjs";
import { IS_EYEJACK_APP } from "../utils/utils";
import MediaRecorderBase from "./mediarecorder.base";
import MediaRecorderApp from "./mediarecorder.app";
import MediaRecorderWeb from "./mediarecorder.web";
import { MediaRecorderResponse } from "./mediarecorder.types";

export default class MediaRecorder extends MediaRecorderBase {
  
  private impl: MediaRecorderBase;
  
  constructor() {
    super();
    if( IS_EYEJACK_APP ) {
      this.impl = new MediaRecorderApp();
    } else {
      this.impl = new MediaRecorderWeb();
    }
  }

  public initWeb(scene:Scene, xr:WebXRDefaultExperience): void {
    if( this.impl instanceof MediaRecorderWeb ) {
      this.impl.init(scene, xr);
    }
  }

  public async start(): Promise<MediaRecorderResponse> {
    return this.impl.start();
  }

  public async stop(): Promise<MediaRecorderResponse> {
    return this.impl.stop();
  }
}